// 2_components/product_variants.js
// Product variant picker (.pv-variants, injected into the short description by the
// variant sync app): turns the "?" help into a focusable CSS tooltip trigger.

export function init() {
	document.querySelectorAll(".pv-variants .pv-help[title]").forEach((help) => {
		help.setAttribute("aria-label", help.getAttribute("title"));
		help.removeAttribute("title");
		help.tabIndex = 0;
	});
}
